import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  Button,
} from '@artstorefronts/ui';
import { TrashIcon, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title?: string;
  description?: string;
  count?: number;
  itemName?: string;
}

export function ConfirmDeleteDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
  title,
  description,
  count = 1,
  itemName,
}: ConfirmDeleteDialogProps) {
  const { t } = useTranslation('common');
  const resolvedTitle = title ?? t('confirm-delete.title');
  const resolvedItemName = itemName ?? t('confirm-delete.default-item-name');
  const defaultDescription = t('confirm-delete.description', { count, itemName: resolvedItemName });

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center">
            <TrashIcon className="w-6 h-6 mr-2" /> {resolvedTitle}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-left">{description || defaultDescription}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              onOpenChange(false);
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();
            }}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}{' '}
            {t('confirm-delete.button', { count, itemName: resolvedItemName })}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
